import React, { useEffect, useState } from 'react';
import { getFirestore, collection, query, orderBy, limit, getDocs } from 'firebase/firestore';
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyDMO-NMJlMX-5M4px24r41ZstkhlBEtaeQ",
    authDomain: "good-news-from-josiah.firebaseapp.com",
    projectId: "good-news-from-josiah",
    storageBucket: "good-news-from-josiah.firebasestorage.app",
    messagingSenderId: "156596562213",
    appId: "1:156596562213:web:bf07b494a7d614025a12cc",
    measurementId: "G-5H5CL8C545"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const analytics = getAnalytics(app);

const HighScores = () => {
    const [scores, setScores] = useState([]);

    useEffect(() => {
        const fetchScores = async () => {
            const q = query(
                collection(db, "bible-trivia"),
                orderBy("score", "desc"),
                limit(3)
            );
            const snapshot = await getDocs(q);
            const results = snapshot.docs.map(doc => doc.data());
            setScores(results);
        };

        fetchScores();
    }, []);

    return (
        <div className="topscores">
            <h2>High Scores</h2>
            <ul>
                {scores.map((entry, i) => (
                    <li key={i}>
                        {entry.name}: {entry.score}
                    </li>
                ))}
            </ul>
            <u>Try to get on the leaderboard!</u>
        </div>
    );
};

export default HighScores;
